const DEFAULT_HEADER_OFFSET = 106

function getTarget(hash) {
  if (!hash) return null
  return document.querySelector(hash)
}

function getTargetTop(target) {
  return window.pageYOffset + target.getBoundingClientRect().top
}

function hasPendingImagesBefore(targetTop) {
  return Array.from(document.images).some((img) => {
    if (img.complete) return false
    const imgTop = window.pageYOffset + img.getBoundingClientRect().top
    return imgTop <= targetTop + window.innerHeight
  })
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function waitForAnchorReady(hash, options = {}) {
  const timeoutMs = options.timeoutMs ?? 7000
  const intervalMs = options.intervalMs ?? 120
  const stableRequired = options.stableRequired ?? 4
  const startedAt = Date.now()
  let stableCount = 0
  let lastTop = null
  let lastHeight = null

  while (Date.now() - startedAt < timeoutMs) {
    const target = getTarget(hash)

    if (target) {
      const currentTop = getTargetTop(target)
      const currentHeight = target.offsetHeight
      const topChanged = lastTop === null || Math.abs(currentTop - lastTop) > 1
      const heightChanged = lastHeight === null || Math.abs(currentHeight - lastHeight) > 1
      lastTop = currentTop
      lastHeight = currentHeight

      if (!topChanged && !heightChanged && !hasPendingImagesBefore(currentTop)) {
        stableCount++
        if (stableCount >= stableRequired) {
          return target
        }
      } else {
        stableCount = 0
      }
    }

    await wait(intervalMs)
  }

  return getTarget(hash)
}

export function scrollToAnchor(hash, offset = DEFAULT_HEADER_OFFSET) {
  const target = getTarget(hash)
  if (!target) return false

  const top = getTargetTop(target) - offset
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: 'smooth'
  })
  return true
}

export function scrollToAnchorImmediate(hash, offset = DEFAULT_HEADER_OFFSET) {
  const target = getTarget(hash)
  if (!target) return false

  const top = getTargetTop(target) - offset
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: 'auto'
  })
  return true
}

export async function scrollToAnchorWhenReady(hash, offset = DEFAULT_HEADER_OFFSET, options = {}) {
  const target = await waitForAnchorReady(hash, options)
  if (!target) return false
  return scrollToAnchor(hash, offset)
}

export function scrollToAnchorIfReady(hash, offset = DEFAULT_HEADER_OFFSET) {
  const target = getTarget(hash)
  if (!target) return false
  return scrollToAnchor(hash, offset)
}
